const PHYSICAL_TYPES = new Set(['item', 'items', 'physical']);

/** Fallback del sitio (mismo que el botón flotante) si Admin aún no cargó un número. */
export const FALLBACK_COMPANY_WHATSAPP = '5491123456789';

export function resolveCompanyWhatsApp(phone) {
  return normalizeWhatsAppDigits(phone) || FALLBACK_COMPANY_WHATSAPP;
}

export function isPhysicalProductType(type) {
  return PHYSICAL_TYPES.has(String(type || '').toLowerCase());
}

export function normalizeWhatsAppDigits(raw) {
  if (raw == null) return '';
  let digits = String(raw).replace(/\D/g, '');
  if (!digits) return '';
  if (digits.startsWith('00')) digits = digits.slice(2);
  if (digits.startsWith('54')) return digits;
  if (digits.startsWith('0')) digits = digits.replace(/^0+/, '');
  if (digits.startsWith('15') && digits.length >= 10) {
    digits = `9${digits.slice(2)}`;
  }
  if (digits.length === 10) return `549${digits}`;
  if (digits.length === 11 && digits.startsWith('9')) return `54${digits}`;
  return digits;
}

export function buildWhatsAppUrl(phoneRaw, message) {
  const digits = normalizeWhatsAppDigits(phoneRaw);
  if (!digits) return '';
  const text = message ? encodeURIComponent(String(message)) : '';
  return text ? `https://wa.me/${digits}?text=${text}` : `https://wa.me/${digits}`;
}

export function formatMoneyArs(amount, currency = 'ARS') {
  const n = Number(amount);
  try {
    return new Intl.NumberFormat('es-AR', {
      style: 'currency',
      currency: currency || 'ARS',
    }).format(Number.isFinite(n) ? n : 0);
  } catch {
    return `$ ${Number.isFinite(n) ? n.toFixed(2) : '0.00'}`;
  }
}

export function buildPhysicalOrderWhatsAppMessage({
  firstName,
  orderNumber,
  totalAmount,
  currency,
  lines,
}) {
  const first = (firstName || '').trim() || 'cliente';
  const physical = (lines || []).filter((line) => isPhysicalProductType(line.productType));
  const source = physical.length > 0 ? physical : lines || [];
  const items = source
    .map((line) => {
      const qty = Math.max(1, parseInt(String(line.quantity || 1), 10) || 1);
      const title = String(line.title || line.name || 'Producto').trim();
      return `- ${title} x${qty}`;
    })
    .join('\n');

  return [
    `Hola Always Aligners, soy ${first}.`,
    'Quiero coordinar el envío de mi compra por WhatsApp.',
    orderNumber ? `Orden: ${orderNumber}` : '',
    items ? `Productos:\n${items}` : '',
    totalAmount != null ? `Total: ${formatMoneyArs(totalAmount, currency)}` : '',
    'Gracias.',
  ]
    .filter(Boolean)
    .join('\n\n');
}

export function orderLinesFromCart(cart) {
  return (cart || []).map((item) => ({
    title: item.variantName ? `${item.name} — ${item.variantName}` : item.name,
    name: item.name,
    quantity: item.quantity,
    unitPrice: item.price,
    productType: item.productType,
  }));
}

export function orderLinesFromPurchase(order) {
  return (order?.items || []).map((item) => ({
    title: item.productName || item.title || item.name || item.product?.name,
    quantity: item.quantity,
    unitPrice: item.unitPrice ?? item.price,
    productType: item.productType || item.product?.type,
  }));
}
